package com.essntl.features.profile.data.supabase

import com.essntl.features.profile.domain.model.ProfileModel
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun ProfileModel.toRequestMap(): Map<String, JsonElement> {
    val profileMap = mutableMapOf<String, JsonElement>()

    if (!firstName.isNullOrEmpty()) {
        profileMap["first_name"] = JsonPrimitive(firstName)
    }

    if (!lastName.isNullOrEmpty()) {
        profileMap["last_name"] = JsonPrimitive(lastName)
    }

    if (!appVersion.isNullOrEmpty()) {
        profileMap["app_version"] = JsonPrimitive(appVersion)
    }

    return profileMap
}